import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import frontendReducers from "../reducers/combinedReducers";
import api from '../login/api.middleware';

let createStoreWithMiddleware = applyMiddleware(thunkMiddleware, api)(
  createStore
);
let store = createStoreWithMiddleware(
  frontendReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
